import React from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchGroups, getGroups, getIsGroupLoading } from "../../reducers/group";
import { getCurrentUser} from '../../reducers/login'
import { Redirect } from "react-router";
import UpdateLessonsPage from "../../components/RoleBased/UpdateLessonsPage";
import { fetchSaveLessons, getIsLessonSaved, getError, getIsLessonLoading, getLessonById, patchLessonById, fetchLessonsById} from "../../reducers/lesson";

const UpdateLessonContainer = props => {
    return props.currentUser?.optional?.role === 'teacher' || props.currentUser?.optional?.role === 'admin' ? <UpdateLessonsPage {...props} /> : <Redirect to ="/noAccess" />
}

const mapState = (state, props) => ({
    lessonId: props.match.params.id,
    currentUser : getCurrentUser(state),
    groups: getGroups(state),
    isLoading: getIsGroupLoading(state) || getIsLessonLoading(state), 
    error: getError(state),
    isLessonSaved: getIsLessonSaved(state),
    lessonById: getLessonById(state)
});

const actions = (dispatch, props) => ({
    fetchGroups: bindActionCreators(fetchGroups, dispatch),
    fetchSaveLessons: bindActionCreators(fetchSaveLessons, dispatch),
    fetchLessonsById: bindActionCreators(fetchLessonsById, dispatch),
    patchLessonById: bindActionCreators(patchLessonById, dispatch)
});

export default connect(mapState, actions)(UpdateLessonContainer);